export default "__VITE_ASSET__c5f2888b__"